exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table td[data-v-d0df0ff0]{\n    word-break: break-all;\n    vertical-align: inherit;\n    border-top: none;\n}\n.whitespace[data-v-d0df0ff0]{\n    white-space: pre-line;\n}\n.sp_play_style[data-v-d0df0ff0] {\n    justify-content: flex-start;\n    display: flex;\n    align-items: center;\n}\n@media screen and (max-width: 896px) {\n.sp_play_style[data-v-d0df0ff0] {\n        justify-content: flex-end;\n}\n}\n", ""]);

// exports
